import { BrowserRouter, HashRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import { useEffect } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { JobProvider } from './contexts/JobContext';
import { useAuth } from './contexts/AuthContext';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import WhatsAppVerification from './pages/WhatsAppVerification';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import Jobs from './pages/Jobs';
import UploadCV from './pages/UploadCV';
import Welcome from './pages/Welcome';
import CompletionRequest from './pages/CompletionRequest';
import DeleteAccount from './pages/DeleteAccount';
import CreateCV from './pages/CreateCV';

const Router = Capacitor.isNativePlatform() ? HashRouter : BrowserRouter;

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: `${location.pathname}${location.search}` }} />;
  }
  
  return children;
};

function App() {
  // Ensure the title is set correctly
  useEffect(() => {
    document.title = 'Rebase - לעבודת הבנייה הבאה שלך';
  }, []);

  return (
    <Router>
      <AuthProvider>
        <JobProvider>
          <div className="min-h-screen bg-gradient-to-b from-[#eef1f3] to-[#d9dee2] rtl" dir="rtl">
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Welcome />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/verify-whatsapp" element={<WhatsAppVerification />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              
              {/* Protected routes */}
              <Route 
                path="/profile" 
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/jobs" 
                element={
                  <ProtectedRoute>
                    <Jobs />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/completion-request"
                element={
                  <ProtectedRoute>
                    <CompletionRequest />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/upload-cv" 
                element={
                  <ProtectedRoute>
                    <UploadCV />
                  </ProtectedRoute>
                } 
              />
              <Route
                path="/create-cv"
                element={
                  <ProtectedRoute>
                    <CreateCV />
                  </ProtectedRoute>
                }
              />
              
              {/* Default route */}
              <Route path="*" element={<Navigate to="/jobs" />} />
            </Routes>
          </div>
        </JobProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
